export default {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: 'us-east-1:fbb09891-723a-48db-80ac-facd1ca9ec4b',
    // REQUIRED - Amazon Cognito Region
    region: 'us-east-1',
    userPoolId: 'us-east-1_EvBbozIjd',
    userPoolWebClientId: 'kpd58387a2f9e4fe1d42sfd1q',
  },
};
